import React from "react";

const comonIcons = {
  info: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>6AB99C0B-0DAC-41B6-B748-720E6DDEBA3A</title>
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -543.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Info" transform="translate(0.000000, 462.000000)">
              <g
                id="person-24px-(2)"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M12,12 C14.21,12 16,10.21 16,8 C16,5.79 14.21,4 12,4 C9.79,4 8,5.79 8,8 C8,10.21 9.79,12 12,12 Z M12,14 C9.33,14 4,15.34 4,18 L4,19 C4,19.55 4.45,20 5,20 L19,20 C19.55,20 20,19.55 20,19 L20,18 C20,15.34 14.67,14 12,14 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  gym: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -594.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Gyms" transform="translate(0.000000, 513.000000)">
              <g
                id="fitness_center-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M20.57,14.86 L21.29,14.14 C21.68,13.75 21.68,13.12 21.29,12.73 L21.27,12.71 C20.88,12.32 20.25,12.32 19.86,12.71 L17,15.57 L8.43,7 L11.29,4.14 C11.68,3.75 11.68,3.12 11.29,2.73 L11.27,2.71 C10.88,2.32 10.25,2.32 9.86,2.71 L9.14,3.43 L8.42,2.71 C8.03,2.32 7.39,2.32 7,2.71 L5.57,4.14 L4.85,3.42 C4.46,3.03 3.81,3.03 3.42,3.42 C3.03,3.81 3.03,4.46 3.42,4.85 L4.14,5.57 L2.71,7 C2.32,7.39 2.32,8.02 2.71,8.41 L3.43,9.13 L2.71,9.86 C2.32,10.25 2.32,10.88 2.71,11.27 L2.73,11.29 C3.12,11.68 3.75,11.68 4.14,11.29 L7,8.43 L15.57,17 L12.71,19.86 C12.32,20.25 12.32,20.88 12.71,21.27 L12.73,21.29 C13.12,21.68 13.75,21.68 14.14,21.29 L14.86,20.57 L15.58,21.29 C15.97,21.68 16.6,21.68 16.99,21.29 L18.42,19.86 L19.14,20.58 C19.53,20.97 20.18,20.97 20.57,20.58 C20.96,20.19 20.96,19.54 20.57,19.15 L19.85,18.43 L21.29,17 C21.68,16.61 21.68,15.98 21.29,15.59 L20.57,14.86 Z"
                  id="Path"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  trainer: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -648.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Trainers" transform="translate(0.000000, 567.000000)">
              <g
                id="self_improvement-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <g id="Group">
                  <rect
                    id="Rectangle"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <rect
                    id="Rectangle"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                </g>
                <g
                  id="Group"
                  transform="translate(3.000000, 4.000000)"
                  fill="#000000"
                  fill-rule="nonzero"
                >
                  <circle id="Oval" cx="9" cy="2" r="2"></circle>
                  <path
                    d="M18,10.94 L18,10.94 C18,10.44 17.64,10.01 17.15,9.96 C15.27,9.75 13.66,8.83 12.4,7.33 L11.06,5.73 C10.68,5.26 10.12,5 9.53,5 L8.48,5 C7.89,5 7.33,5.26 6.95,5.72 L5.61,7.32 C4.36,8.82 2.74,9.74 0.86,9.95 C0.36,10.01 0,10.44 0,10.94 L0,10.94 C0,11.54 0.53,12.01 1.13,11.94 C3.43,11.67 5.45,10.55 7,8.75 L7,11 L3.24,12.5 C2.59,12.76 2.08,13.33 2.01,14.03 C1.91,15.1 2.74,16 3.79,16 L6,16 L6,15.5 C6,14.12 7.12,13 8.5,13 L11.5,13 C11.78,13 12,13.22 12,13.5 C12,13.78 11.78,14 11.5,14 L8.5,14 C7.67,14 7,14.67 7,15.5 L7,16 L14.1,16 C14.95,16 15.75,15.46 15.95,14.63 C16.16,13.74 15.68,12.87 14.87,12.55 L11,11 L11,8.75 C12.56,10.55 14.57,11.66 16.87,11.94 C17.47,12 18,11.54 18,10.94 Z"
                    id="Path"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  terms: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -702.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Trainers" transform="translate(0.000000, 621.000000)">
              <g
                id="description-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M14.59,2.59 C14.21,2.21 13.7,2 13.17,2 L6,2 C4.9,2 4,2.9 4,4 L4,20 C4,21.1 4.89,22 5.99,22 L18,22 C19.1,22 20,21.1 20,20 L20,8.83 C20,8.3 19.79,7.79 19.41,7.42 L14.59,2.59 Z M15,18 L9,18 C8.45,18 8,17.55 8,17 C8,16.45 8.45,16 9,16 L15,16 C15.55,16 16,16.45 16,17 C16,17.55 15.55,18 15,18 Z M15,14 L9,14 C8.45,14 8,13.55 8,13 C8,12.45 8.45,12 9,12 L15,12 C15.55,12 16,12.45 16,13 C16,13.55 15.55,14 15,14 Z M13,8 L13,3.5 L18.5,9 L14,9 C13.45,9 13,8.55 13,8 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  privacy: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -756.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Users" transform="translate(0.000000, 675.000000)">
              <g
                id="privacy_tip-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                <path
                  d="M4.19,4.47 C3.47,4.79 3,5.51 3,6.3 L3,11 C3,16.55 6.84,21.74 12,23 C17.16,21.74 21,16.55 21,11 L21,6.3 C21,5.51 20.53,4.79 19.81,4.47 L12.81,1.36 C12.29,1.13 11.7,1.13 11.19,1.36 L4.19,4.47 Z M12,7 L12,7 C12.55,7 13,7.45 13,8 L13,8 C13,8.55 12.55,9 12,9 L12,9 C11.45,9 11,8.55 11,8 L11,8 C11,7.45 11.45,7 12,7 Z M12,11 L12,11 C12.55,11 13,11.45 13,12 L13,16 C13,16.55 12.55,17 12,17 L12,17 C11.45,17 11,16.55 11,16 L11,12 C11,11.45 11.45,11 12,11 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  mailtemplate: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -810.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g
              id="Manage-EMail-Templates"
              transform="translate(0.000000, 729.000000)"
            >
              <g
                id="all_inbox-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,12 C3,13.1 3.9,14 5,14 L19,14 C20.1,14 21,13.1 21,12 L21,5 C21,3.9 20.1,3 19,3 Z M19,9 L15.86,9 C15.39,9 15.02,9.33 14.89,9.78 C14.53,11.04 13.35,12 12,12 C10.65,12 9.47,11.04 9.11,9.78 C8.98,9.33 8.61,9 8.14,9 L5,9 L5,6 C5,5.45 5.45,5 6,5 L18,5 C18.55,5 19,5.45 19,6 L19,9 Z M15.87,16 L20,16 C20.55,16 21,16.45 21,17 L21,19 C21,20.1 20.1,21 19,21 L5,21 C3.9,21 3,20.1 3,19 L3,17 C3,16.45 3.45,16 4,16 L8.13,16 C8.6,16 8.98,16.34 9.11,16.8 C9.46,18.07 10.62,19 12,19 C13.38,19 14.54,18.07 14.89,16.8 C15.02,16.34 15.4,16 15.87,16 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  social: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -864.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Social-media" transform="translate(0.000000, 783.000000)">
              <g id="share-24px" transform="translate(32.000000, 11.000000)">
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M18,16.08 C17.24,16.08 16.56,16.38 16.04,16.85 L8.91,12.7 C8.96,12.47 9,12.24 9,12 C9,11.76 8.96,11.53 8.91,11.3 L15.96,7.19 C16.5,7.69 17.21,8 18,8 C19.66,8 21,6.66 21,5 C21,3.34 19.66,2 18,2 C16.34,2 15,3.34 15,5 C15,5.24 15.04,5.47 15.09,5.7 L8.04,9.81 C7.5,9.31 6.79,9 6,9 C4.34,9 3,10.34 3,12 C3,13.66 4.34,15 6,15 C6.79,15 7.5,14.69 8.04,14.19 L15.16,18.35 C15.11,18.56 15.08,18.78 15.08,19 C15.08,20.61 16.39,21.92 18,21.92 C19.61,21.92 20.92,20.61 20.92,19 C20.92,17.39 19.61,16.08 18,16.08 Z"
                  id="Path"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  admin: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Gym-Info" transform="translate(-32.000000, -836.000000)">
          <g id="Social-media" transform="translate(0.000000, 825.000000)">
            <g
              id="admin_panel_settings-24px"
              transform="translate(32.000000, 11.000000)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
              </g>
              <g
                id="Group"
                transform="translate(3.000000, 3.000000)"
                fill="#000000"
                fill-rule="nonzero"
              >
                <path
                  d="M14,8 C14.34,8 14.67,8.04 15,8.09 L15,4.58 C15,3.78 14.53,3.06 13.8,2.75 L8.3,0.35 C7.79,0.13 7.21,0.13 6.7,0.35 L1.2,2.75 C0.47,3.07 0,3.79 0,4.58 L0,8.18 C0,12.72 3.2,16.97 7.5,18 C8.05,17.87 8.58,17.68 9.1,17.45 C8.41,16.47 8,15.28 8,14 C8,10.69 10.69,8 14,8 Z"
                  id="Path"
                ></path>
                <path
                  d="M14,10 C11.79,10 10,11.79 10,14 C10,16.21 11.79,18 14,18 C16.21,18 18,16.21 18,14 C18,11.79 16.21,10 14,10 Z M14,11.38 C14.62,11.38 15.12,11.89 15.12,12.5 C15.12,13.11 14.61,13.62 14,13.62 C13.39,13.62 12.88,13.11 12.88,12.5 C12.88,11.89 13.38,11.38 14,11.38 Z M14,16.75 C13.07,16.75 12.26,16.29 11.76,15.58 C11.81,14.86 13.27,14.5 14,14.5 C14.73,14.5 16.19,14.86 16.24,15.58 C15.74,16.29 14.93,16.75 14,16.75 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  accounting: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g
          id="Editing-Super-Admin-Info"
          transform="translate(-32.000000, -836.000000)"
        >
          <g id="Accounting-Tab" transform="translate(0.000000, 825.000000)">
            <g
              id="card_membership-24px"
              transform="translate(32.000000, 11.000000)"
            >
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path
                d="M20,2 L4,2 C2.89,2 2,2.89 2,4 L2,15 C2,16.11 2.89,17 4,17 L8,17 L8,22 L12,20 L16,22 L16,17 L20,17 C21.11,17 22,16.11 22,15 L22,4 C22,2.89 21.11,2 20,2 Z M20,15 L4,15 L4,13 L20,13 L20,15 Z M20,10 L4,10 L4,5 C4,4.45 4.45,4 5,4 L19,4 C19.55,4 20,4.45 20,5 L20,10 Z"
                id="Shape"
                fill="#000000"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  excel: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Exporting-Data" transform="translate(-1169.000000, -212.000000)">
          <g id="Excel" transform="translate(1169.000000, 212.000000)">
            <image id="Bitmap" x="2" y="3" width="20" height="18"></image>
            <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
          </g>
        </g>
      </g>
    </svg>
  ),
  pdf: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Exporting-Data" transform="translate(-1169.000000, -258.000000)">
          <g
            id="picture_as_pdf-24px"
            transform="translate(1169.000000, 258.000000)"
          >
            <polygon id="Path" points="0 0 24 0 24 24 0 24" />
            <path
              d="M20,2 L8,2 C6.9,2 6,2.9 6,4 L6,16 C6,17.1 6.9,18 8,18 L20,18 C21.1,18 22,17.1 22,16 L22,4 C22,2.9 21.1,2 20,2 Z M11.5,9.5 C11.5,10.33 10.83,11 10,11 L9,11 L9,13 L7.5,13 L7.5,7 L10,7 C10.83,7 11.5,7.67 11.5,8.5 L11.5,9.5 Z M16.5,11.5 C16.5,12.33 15.83,13 15,13 L12.5,13 L12.5,7 L15,7 C15.83,7 16.5,7.67 16.5,8.5 L16.5,11.5 Z M20.5,8.5 L19,8.5 L19,9.5 L20.5,9.5 L20.5,11 L19,11 L19,13 L17.5,13 L17.5,7 L20.5,7 L20.5,8.5 Z M9,9.5 L10,9.5 L10,8.5 L9,8.5 L9,9.5 Z M4,6 L2,6 L2,20 C2,21.1 2.9,22 4,22 L18,22 L18,20 L4,20 L4,6 Z M14,11.5 L15,11.5 L15,8.5 L14,8.5 L14,11.5 Z"
              id="Shape"
              fill="#4A90E2"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  downarrow: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Admin-Dashboard" transform="translate(-342.000000, -270.000000)">
          <g id="Group-10" transform="translate(324.000000, 166.000000)">
            <g
              id="arrow_drop_up-24px"
              transform="translate(18.000000, 104.000000)"
            >
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path
                d="M8.71,12.29 L11.3,9.7 C11.69,9.31 12.32,9.31 12.71,9.7 L15.3,12.29 C15.93,12.92 15.48,14 14.59,14 L9.41,14 C8.52,14 8.08,12.92 8.71,12.29 Z"
                id="Path"
                fill="#417505"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  close: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <g>
        <g>
          <path
            fill="#17468f"
            d="M0 13C0 5.82 5.82 0 13 0s13 5.82 13 13-5.82 13-13 13S0 20.18 0 13z"
          />
        </g>
        <g>
          <path
            fill="#fff"
            d="M13.825 13.36L17.784 9.4a.357.357 0 1 0-.505-.504l-3.958 3.958-3.959-3.958a.357.357 0 1 0-.504.504l3.958 3.959-3.958 3.958a.357.357 0 1 0 .504.505l3.959-3.959 3.958 3.959a.356.356 0 0 0 .505 0 .357.357 0 0 0 0-.505z"
          />
          <path
            fill="none"
            stroke="#fff"
            stroke-miterlimit="20"
            d="M13.825 13.36v0L17.784 9.4a.357.357 0 1 0-.505-.504l-3.958 3.958v0L9.362 8.897a.357.357 0 1 0-.504.504l3.958 3.959v0l-3.958 3.958a.357.357 0 1 0 .504.505l3.959-3.959v0l3.958 3.959a.356.356 0 0 0 .505 0 .357.357 0 0 0 0-.505z"
          />
        </g>
      </g>
    </svg>
  ),
  closeSecond: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Reserving-Class"
          transform="translate(-1170.000000, -150.000000)"
        >
          <g id="Classes-Table" transform="translate(222.000000, 130.000000)">
            <g
              id="highlight_off-24px"
              transform="translate(948.000000, 20.000000)"
            >
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path
                d="M13.89,8.7 L12,10.59 L10.11,8.7 C9.72,8.31 9.09,8.31 8.7,8.7 C8.31,9.09 8.31,9.72 8.7,10.11 L10.59,12 L8.7,13.89 C8.31,14.28 8.31,14.91 8.7,15.3 C9.09,15.69 9.72,15.69 10.11,15.3 L12,13.41 L13.89,15.3 C14.28,15.69 14.91,15.69 15.3,15.3 C15.69,14.91 15.69,14.28 15.3,13.89 L13.41,12 L15.3,10.11 C15.69,9.72 15.69,9.09 15.3,8.7 C14.91,8.32 14.27,8.32 13.89,8.7 Z M12,2 C6.47,2 2,6.47 2,12 C2,17.53 6.47,22 12,22 C17.53,22 22,17.53 22,12 C22,6.47 17.53,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z"
                id="Shape"
                fill="#000000"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  clock: (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Finals"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.8"
      >
        <g
          id="Home-page-(Registered-User)"
          transform="translate(-120.000000, -1289.000000)"
        >
          <g id="timer-24px" transform="translate(120.000000, 1289.000000)">
            <polygon id="Path" points="0 0 18 0 18 18 0 18"></polygon>
            <path
              d="M10.5,0.75 L7.5,0.75 C7.0875,0.75 6.75,1.0875 6.75,1.5 C6.75,1.9125 7.0875,2.25 7.5,2.25 L10.5,2.25 C10.9125,2.25 11.25,1.9125 11.25,1.5 C11.25,1.0875 10.9125,0.75 10.5,0.75 Z M9,10.5 C9.4125,10.5 9.75,10.1625 9.75,9.75 L9.75,6.75 C9.75,6.3375 9.4125,6 9,6 C8.5875,6 8.25,6.3375 8.25,6.75 L8.25,9.75 C8.25,10.1625 8.5875,10.5 9,10.5 Z M14.2725,5.5425 L14.835,4.98 C15.12,4.695 15.1275,4.2225 14.835,3.93 L14.8275,3.9225 C14.535,3.63 14.07,3.6375 13.7775,3.9225 L13.215,4.485 C12.0525,3.555 10.59,3 9,3 C5.4,3 2.34,5.97 2.25,9.57 C2.1525,13.38 5.205,16.5 9,16.5 C12.735,16.5 15.75,13.4775 15.75,9.75 C15.75,8.16 15.195,6.6975 14.2725,5.5425 Z M9,15 C6.0975,15 3.75,12.6525 3.75,9.75 C3.75,6.8475 6.0975,4.5 9,4.5 C11.9025,4.5 14.25,6.8475 14.25,9.75 C14.25,12.6525 11.9025,15 9,15 Z"
              id="Shape"
              fill="#000000"
              fill-rule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  notification: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="32"
      viewBox="0 0 25 32"
    >
      <g>
        <g>
          <path
            fill="#FF9E00"
            d="M8.508 27.817v.025a3.745 3.745 0 1 0 7.49 0v-.025z"
          />
        </g>
        <g>
          <path
            fill="#FF9E00"
            d="M24.21 23.136l-3.37-4.951v-6.178a8.59 8.59 0 0 0-6.903-8.421V1.684a1.684 1.684 0 0 0-3.368 0v1.902a8.59 8.59 0 0 0-6.903 8.421v6.178l-3.37 4.951a1.703 1.703 0 0 0 1.407 2.66h21.1a1.703 1.703 0 0 0 1.407-2.66z"
          />
        </g>
      </g>
    </svg>
  ),
  mappin: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Map"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Group-7"
          transform="translate(4.000000, 1.000000)"
          fill="#606C74"
        >
          <g id="Group-6" transform="translate(0.000000, 0.500450)">
            <path
              d="M8.00005,0.49545 C7.77555,0.49545 7.55305,0.50345 7.33305,0.51845 C0.48705,0.99395 -2.45295,9.76245 2.39905,14.74495 L8.00005,20.49595 L13.60055,14.74495 C18.45205,9.76245 15.51255,0.99395 8.66655,0.51845 C8.44655,0.50345 8.22355,0.49545 8.00005,0.49545 M8.00005,2.49545 C8.17605,2.49545 8.35355,2.50195 8.52805,2.51395 C10.81055,2.67245 12.68705,4.11245 13.54755,6.36645 C14.28505,8.29945 14.31055,11.14945 12.16805,13.34945 L8.00005,17.62945 L3.83155,13.34945 C1.68905,11.14945 1.71405,8.29945 2.45205,6.36645 C3.31255,4.11245 5.18905,2.67245 7.47105,2.51395 C7.64605,2.50195 7.82355,2.49545 8.00005,2.49545"
              id="Fill-2"
            ></path>
            <path
              d="M8.00005,4.4959 C5.79105,4.4959 4.00005,6.2869 4.00005,8.4959 C4.00005,10.7049 5.79105,12.4959 8.00005,12.4959 C10.20905,12.4959 12.00005,10.7049 12.00005,8.4959 C12.00005,6.2869 10.20905,4.4959 8.00005,4.4959 M8.00005,6.4959 C9.10255,6.4959 10.00005,7.3929 10.00005,8.4959 C10.00005,9.5989 9.10255,10.4959 8.00005,10.4959 C6.89755,10.4959 6.00005,9.5989 6.00005,8.4959 C6.00005,7.3929 6.89755,6.4959 8.00005,6.4959"
              id="Fill-4"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  startloop: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Finals"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Gyms-tab" transform="translate(-1174.000000, -265.000000)">
          <g id="Gym-Card" transform="translate(460.000000, 235.000000)">
            <g id="Kettlebell" transform="translate(714.000000, 30.000000)">
              <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
              <path
                d="M20.3279699,2.46264328 C20.1567339,2.16601407 19.9420822,1.8923062 19.6896777,1.64853092 C19.4370036,1.40448598 19.0705317,1.12835115 18.7477452,0.951452271 C14.632689,-0.395244358 9.00859908,-0.215379189 5.19718335,0.884306204 C4.88113841,1.05931744 4.28329571,1.41176688 4.03925077,1.65311519 C3.79493616,1.89473317 3.58702605,2.16628373 3.4157901,2.46264328 C2.7313856,3.64835115 2.83223953,5.18354216 3.69300358,6.67450845 L5.80176762,10.3268231 C4.41974515,11.7970253 3.57273392,13.7782388 3.57273392,15.9554972 C3.57273392,19.8286658 6.25372268,23.0759467 9.86100358,23.9434523 L13.7163744,23.9434523 C17.3241946,23.0759467 20.0049137,19.8286658 20.0049137,15.9554972 C20.0049137,13.8327107 19.1999699,11.8951826 17.8780822,10.4371152 L20.0507564,6.67450845 C20.9112508,5.18354216 21.0123744,3.64835115 20.3279699,2.46264328 Z M16.9722845,6.58255339 C16.7535878,6.96169946 16.4982171,7.40394665 16.2247789,7.87774441 C16.0637901,8.15657587 15.8965991,8.44619384 15.7264418,8.74039609 C14.557453,8.10075564 13.2156103,7.73698036 11.7890935,7.73698036 C10.4135429,7.73698036 9.1175429,8.07540733 7.97848672,8.67298036 C7.82181257,8.40196913 7.6681047,8.1352725 7.51925077,7.87801407 C7.24581257,7.40421632 6.99044178,6.96196913 6.77147549,6.58255339 C6.29390245,5.67810396 5.33255414,4.7170253 5.84518335,3.62731744 C6.10163279,3.17859834 6.9168238,3.0494298 7.45183504,3.00628373 C7.45183504,3.00628373 7.80805976,2.93239609 8.68958785,2.87360957 C11.341453,2.6967107 13.8633407,2.63280059 16.8226216,3.05050845 C17.0148912,3.11441856 17.4460822,3.24277811 17.6380822,3.370868 C18.5352508,4.46057587 17.5099923,5.61392418 16.9722845,6.58255339 Z"
                id="Shape"
                fill="#F6A51F"
                fill-rule="nonzero"
              ></path>
              <g id="star-24px" transform="translate(5.000000, 9.000000)">
                <g id="Group">
                  <polygon id="Path" points="0 0 14 0 14 14 0 14"></polygon>
                  <polygon id="Path" points="0 0 14 0 14 14 0 14"></polygon>
                </g>
                <path
                  d="M7,10.0741667 L9.42083333,11.5383333 C9.86416667,11.8066667 10.4066667,11.41 10.29,10.9083333 L9.64833333,8.155 L11.7891667,6.3 C12.18,5.96166667 11.97,5.32 11.4566667,5.27916667 L8.63916667,5.04 L7.53666667,2.43833333 C7.33833333,1.96583333 6.66166667,1.96583333 6.46333333,2.43833333 L5.36083333,5.03416667 L2.54333333,5.27333333 C2.03,5.31416667 1.82,5.95583333 2.21083333,6.29416667 L4.35166667,8.14916667 L3.71,10.9025 C3.59333333,11.4041667 4.13583333,11.8008333 4.57916667,11.5325 L7,10.0741667 Z"
                  id="Path"
                  fill="#9E6A14"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  member: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Gym-Info" transform="translate(-32.000000, -515.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Users" transform="translate(0.000000, 434.000000)">
              <g
                id="assignment_ind-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M19,3 L14.82,3 C14.4,1.84 13.3,1 12,1 C10.7,1 9.6,1.84 9.18,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M12,2.75 C12.22,2.75 12.41,2.85 12.55,3 C12.67,3.13 12.75,3.31 12.75,3.5 C12.75,3.91 12.41,4.25 12,4.25 C11.59,4.25 11.25,3.91 11.25,3.5 C11.25,3.31 11.33,3.13 11.45,3 C11.59,2.85 11.78,2.75 12,2.75 Z M19,19 L5,19 L5,5 L19,5 L19,19 Z M12,6 C10.35,6 9,7.35 9,9 C9,10.65 10.35,12 12,12 C13.65,12 15,10.65 15,9 C15,7.35 13.65,6 12,6 Z M12,10 C11.45,10 11,9.55 11,9 C11,8.45 11.45,8 12,8 C12.55,8 13,8.45 13,9 C13,9.55 12.55,10 12,10 Z M6,16.47 L6,18 L18,18 L18,16.47 C18,13.97 14.03,12.89 12,12.89 C9.97,12.89 6,13.96 6,16.47 Z M8.31,16 C9,15.44 10.69,14.88 12,14.88 C13.31,14.88 15.01,15.44 15.69,16 L8.31,16 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  setting: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Gym-Admin"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Gym-Info" transform="translate(-32.000000, -731.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Appointments" transform="translate(0.000000, 650.000000)">
              <g id="lock-24px-(1)" transform="translate(32.000000, 11.000000)">
                <g id="Group">
                  <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                  <polygon
                    id="Path"
                    opacity="0.87"
                    points="0 0 24 0 24 24 0 24"
                  ></polygon>
                </g>
                <path
                  d="M18,8 L17,8 L17,6 C17,3.24 14.76,1 12,1 C9.24,1 7,3.24 7,6 L7,8 L6,8 C4.9,8 4,8.9 4,10 L4,20 C4,21.1 4.9,22 6,22 L18,22 C19.1,22 20,21.1 20,20 L20,10 C20,8.9 19.1,8 18,8 Z M12,17 C10.9,17 10,16.1 10,15 C10,13.9 10.9,13 12,13 C13.1,13 14,13.9 14,15 C14,16.1 13.1,17 12,17 Z M9,8 L9,6 C9,4.34 10.34,3 12,3 C13.66,3 15,4.34 15,6 L15,8 L9,8 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  signout: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="0.5"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -1682.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Sign-Out" transform="translate(0.000000, 1601.000000)">
              <g
                id="power_settings_new-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M12,3 C11.45,3 11,3.45 11,4 L11,12 C11,12.55 11.45,13 12,13 C12.55,13 13,12.55 13,12 L13,4 C13,3.45 12.55,3 12,3 Z M17.14,5.86 C16.75,6.25 16.76,6.86 17.13,7.25 C18.26,8.45 18.96,10.05 19,11.82 C19.09,15.65 15.92,18.95 12.09,18.99 C8.18,19.05 5,15.9 5,12 C5,10.16 5.71,8.49 6.87,7.24 C7.24,6.85 7.24,6.24 6.86,5.86 C6.46,5.46 5.81,5.47 5.43,5.88 C3.98,7.42 3.07,9.47 3,11.74 C2.86,16.62 6.83,20.84 11.71,20.99 C16.81,21.15 21,17.06 21,11.99 C21,9.62 20.08,7.48 18.58,5.88 C18.2,5.47 17.54,5.46 17.14,5.86 L17.14,5.86 Z"
                  id="Shape"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  gym: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        opacity="1"
      >
        <g id="Admin-Dashboard" transform="translate(-32.000000, -594.000000)">
          <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
            <g id="Gyms" transform="translate(0.000000, 513.000000)">
              <g
                id="fitness_center-24px"
                transform="translate(32.000000, 11.000000)"
              >
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M20.57,14.86 L21.29,14.14 C21.68,13.75 21.68,13.12 21.29,12.73 L21.27,12.71 C20.88,12.32 20.25,12.32 19.86,12.71 L17,15.57 L8.43,7 L11.29,4.14 C11.68,3.75 11.68,3.12 11.29,2.73 L11.27,2.71 C10.88,2.32 10.25,2.32 9.86,2.71 L9.14,3.43 L8.42,2.71 C8.03,2.32 7.39,2.32 7,2.71 L5.57,4.14 L4.85,3.42 C4.46,3.03 3.81,3.03 3.42,3.42 C3.03,3.81 3.03,4.46 3.42,4.85 L4.14,5.57 L2.71,7 C2.32,7.39 2.32,8.02 2.71,8.41 L3.43,9.13 L2.71,9.86 C2.32,10.25 2.32,10.88 2.71,11.27 L2.73,11.29 C3.12,11.68 3.75,11.68 4.14,11.29 L7,8.43 L15.57,17 L12.71,19.86 C12.32,20.25 12.32,20.88 12.71,21.27 L12.73,21.29 C13.12,21.68 13.75,21.68 14.14,21.29 L14.86,20.57 L15.58,21.29 C15.97,21.68 16.6,21.68 16.99,21.29 L18.42,19.86 L19.14,20.58 C19.53,20.97 20.18,20.97 20.57,20.58 C20.96,20.19 20.96,19.54 20.57,19.15 L19.85,18.43 L21.29,17 C21.68,16.61 21.68,15.98 21.29,15.59 L20.57,14.86 Z"
                  id="Path"
                  fill="#000000"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  true: (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin-account"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Successully-Exporting-data"
          transform="translate(-626.000000, -90.000000)"
        >
          <g id="Toast-Message" transform="translate(255.000000, 70.000000)">
            <g
              id="check_circle-24px"
              transform="translate(371.000000, 20.000000)"
            >
              <polygon id="Path" points="0 0 32 0 32 32 0 32"></polygon>
              <path
                d="M16,2.66666667 C8.64,2.66666667 2.66666667,8.64 2.66666667,16 C2.66666667,23.36 8.64,29.3333333 16,29.3333333 C23.36,29.3333333 29.3333333,23.36 29.3333333,16 C29.3333333,8.64 23.36,2.66666667 16,2.66666667 Z M12.3866667,21.72 L7.6,16.9333333 C7.08,16.4133333 7.08,15.5733333 7.6,15.0533333 C8.12,14.5333333 8.96,14.5333333 9.48,15.0533333 L13.3333333,18.8933333 L22.5066667,9.72 C23.0266667,9.2 23.8666667,9.2 24.3866667,9.72 C24.9066667,10.24 24.9066667,11.08 24.3866667,11.6 L14.2666667,21.72 C13.76,22.24 12.9066667,22.24 12.3866667,21.72 Z"
                id="Shape"
                fill="#417505"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
};

export const ComonIcons = comonIcons;
